import { getWamazingAfidFromCookie } from '../../../utils/trackingHelper';

const wamazingTrackItemPurchased = (amount: number, uid1: string, uid2: string) => {
  const afid = getWamazingAfidFromCookie();
  if (!afid) { return; }
  global.console.log('WAmazing Affiliate Conversion', uid1, uid2);
  fetch('/snow/api/v1/affiliate/actions', {
    method: 'POST',
    body: JSON.stringify({ afid, uid1, uid2, amount }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export { wamazingTrackItemPurchased }
